import Vue from 'vue'
import store from '../store'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Login from '@/pages/Login'
import NewMain from '@/pages/NewMain'
import User from '@/pages/user'
import Company from '@/pages/company'
import AddCompany from '@/pages/company/AddCompany'


import Main  from '@/pages/first'

import Finance from '@/pages/finance'
import CashManagement from '@/pages/finance/CashManagement'
import WaitTurn from '@/pages/finance/WaitTurn'
import Complete from '@/pages/finance/Complete'

import UserDealData from '@/pages/finance/UserDealData'
import MerchantDealData from '@/pages/finance/MerchantDealData'
import CompanyDealData from '@/pages/finance/CompanyDealData'
import ReCharge from '@/pages/finance/ReCharge'
import Bill from '@/pages/finance/Bill'

import Merchant from '@/pages/merchant'
import addMerchant from '@/pages/merchant/addMerchant'
import details from '@/pages/merchant/details'
import ratetpl from '@/pages/merchant/ratetpl'
import RateTpl from '@/pages/merchant/ratetpl'
import deposit from '@/pages/merchant/deposit'


import Park from '@/pages/park'
import CircleManage from '@/pages/park/CircleManage'
import CircleFeedBack from '@/pages/park/CircleFeedBack'
import AddInform from '@/pages/park/AddInform'
import System from '@/pages/system'
import SetInfo from '@/pages/system/SetInfo'

import consumerCoupon from '@/pages/salesPromotion/consumerCoupon'
import addCoupon from '@/pages/salesPromotion/addCoupon'


// import UserList from '@/pages/permissions/UserList'//权限-用户列表
import UserManage from '@/pages/permissions/UserManage'//权限-用户管理
import RoleManger from '@/pages/permissions/RoleManage'//权限-用户管理

import Test from '@/pages/Test'

Vue.use(Router)

const subRouter = [
  {
    path: '/',
    name: '首页',
    component: Main
  },
  {
    path: '/test',
    name: 'test',
    component: Test
  },
  {
    path: '/main/user',
    name: '用户管理',
    component: User
  },
  {
    path: '/main/company',
    name: '企业管理',
    component: Company,
  },
  {
    path: '/main/company/AddCompany',
    name: '新增企业',
    component: AddCompany,
  },

  {
    path: '/main/finance',
    name: '财务管理',
    component: Finance,
    children: []
  },
  {
    path: '/main/merchant',
    name: '商户管理',
    component: Merchant,
  },
  {
    path: '/main/addMerchant',
    name: '签约用户',
    component: addMerchant,
  },
  {
    path: '/main/ratetpl',
    name: '结算周期',
    component: ratetpl,
  },
  // {
  //   path: '/main/detail',
  //   name: '商户详情',
  //   component: detail,
  // },
  {
    path: '/main/details',
    name: '商户详情',
    component: details,
  },
  {
    path: '/main/deposit',
    name: '提现数据',
    component: deposit,
  },
  {
    path: '/main/park',
    name: '园区管理',
    component: Park,
  },
  {
    path: '/main/CircleManage',
    name: '圆圈管理',
    component: CircleManage,
  },
  {
    path: '/main/CircleFeedBack',
    name: '反馈列表',
    component: CircleFeedBack,
  },
  {
    path: '/main/park/AddInform',
    name: '通知',
    component: AddInform,
  },


  {
    path: '/main/system',
    name: '系统通知',
    component: System,
  },
  {
    path: '/main/ratetpl',
    name: '费率模版',
    component: RateTpl
  },
  {
    path: '/main/userdeal',
    name: '个人交易数据',
    component: UserDealData
  },
  {
    path: '/main/merchantdeal',
    name: '商户交易数据',
    component :MerchantDealData
  },
  {
    path: '/main/companydeal',
    name: '企业交易数据',
    component :CompanyDealData
  },
  {
    path: '/main/recharge',
    name: '企业充值',
    component: ReCharge
  },
  {
    path: '/main/CashManagement',
    name: '待审核',
    component: CashManagement
  },
  {
    path: '/main/waitturn',
    name:'待转账',
    component:WaitTurn
  },
  {
    path: '/main/complete',
    name:'提现完成',
    component: Complete
  },
  {
    path: '/main/Bill',
    name: '待发票',
    component: Bill
  },
  {
    path: '/main/usermanage',
    name: '用户列表',
    component: UserManage
  },
  {
    path: '/main/rolemanger',
    name: '角色管理',
    component: RoleManger
  },
  {
    path:'/main/consumerCoupon',
    name:'消费券',
    component :consumerCoupon
  },
  {
    path:'/main/addCoupon',
    name:'新建店铺券',
    component :addCoupon
  },
]
const mainRoute = [
  {
    path: '/',
    name: '登录',
    component: Login
  },
  {
    path: '/main',
    component: NewMain,
    children:subRouter
  },
];
const router = new Router({
  routes:mainRoute
})
router.beforeEach((to,from,next)=>{
  store.commit('SET_ROUTER',subRouter);
  next();
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js